import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import FieldSelect from '../../../form/field_select/field_select.jsx'
import IconButton from '../../../common/icon_button/icon_button.jsx'

class SupplierForm extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      keyword: '',
      supplierName: ''
    }
  }

  static get propTypes () {
    return {
      supplierOptions: PropTypes.array,
      onSelectSupplier: PropTypes.func,
      onAddSupplier: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      supplierOptions: [],
      onSelectSupplier: null,
      onAddSupplier: null
    }
  }

  render () {
    const { keyword } = this.state
    const { supplierOptions } = this.props

    const keywordLower = keyword ? keyword.toLowerCase() : ''
    const showAdd =
      _.findIndex(
        supplierOptions,
        opt => opt.label.toLowerCase() === keywordLower
      ) === -1

    return (
      <div className='supplierform'>
        <FieldSelect
          inputValue={keyword}
          options={supplierOptions}
          onInputChange={this._onInputChange} // eslint-disable-line react/jsx-handler-names
          onChange={this._onSelectSupplier} // eslint-disable-line react/jsx-handler-names
          onMenuClose={this._onMenuClose} // eslint-disable-line react/jsx-handler-names
          onMenuOpen={this._onMenuOpen} // eslint-disable-line react/jsx-handler-names
        />
        <IconButton
          icon='+'
          size='small'
          type='secondary'
          className='addsupplier'
          disabled={!showAdd}
          onClick={showAdd ? this._onAddSupplier : null}
        />
      </div>
    )
  }

  /* Event handlers */
  _onInputChange = value => {
    this.setState({ keyword: value })
  }

  _onMenuOpen = () => {
    this.setState({ supplierName: '' })
  }

  _onMenuClose = () => {
    const { keyword } = this.state
    this.setState({ supplierName: keyword })
  }

  _onSelectSupplier = supplier => {
    this.setState({ keyword: '', supplierName: '' })

    if (this.props.onSelectSupplier) {
      this.props.onSelectSupplier(supplier)
    }
  }

  _onAddSupplier = () => {
    const { supplierName } = this.state

    if (this.props.onAddSupplier && supplierName) {
      this.props.onAddSupplier(supplierName)
    }

    this.setState({ keyword: '', supplierName: '' })
  }
}

export default SupplierForm
